import * as fromDatatype from '../datatype-library/index';

export interface app_tenant_deletion_event_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  tenant_guid: fromDatatype.GuidDataFieldInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  message_json: fromDatatype.JsonDatatypeInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  date_completed: fromDatatype.TimestampTzDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
}

export class app_tenant_deletion_event_hdr_RowClass
  implements app_tenant_deletion_event_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    tenant_guid: fromDatatype.GuidDataFieldInterface;
    action: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    message_json: fromDatatype.JsonDatatypeInterface;
    date_created: fromDatatype.TimestampTzDatatypeInterface;
    date_updated: fromDatatype.TimestampTzDatatypeInterface;
    date_completed: fromDatatype.TimestampTzDatatypeInterface;
    event_code: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}